package com.appsyde.shared.modules.ai.domain.model

enum class AiRefineAction {
    GRAMMAR,
    TONE_PRO,
    TONE_BALANCED,
    TONE_WARM,
    SHORTEN
}

/** Label for tone actions (harmonisé avec Mon compte). */
fun AiRefineAction.toneLabelOrNull(): String? = when (this) {
    AiRefineAction.TONE_PRO -> "Professionnel"
    AiRefineAction.TONE_BALANCED -> "Équilibré"
    AiRefineAction.TONE_WARM -> "Chaleureux"
    else -> null
}

/** Refine action for the current account tone index (0=Pro, 1=Balanced, 2=Warm). */
fun toneIndexToRefineAction(index: Int): AiRefineAction = when (index.coerceIn(0, 2)) {
    0 -> AiRefineAction.TONE_PRO
    1 -> AiRefineAction.TONE_BALANCED
    else -> AiRefineAction.TONE_WARM
}
